<template>
  <div class="d-flex flex-column">
    <span class="f15 black1 font-weight-bold mb-3">
      {{ headerText }}
    </span>
    <div class="f15 gray1 mb-4 lato-italic" style="display: flex; gap: 8px">
      {{ subHeaderText }}
    </div>
    <v-combobox
      v-model="localValue"
      class="approvers-box"
      item-text="name"
      multiple
      chips
      :items="admins"
      hide-details
      outlined
    >
      <template #selection="{ attrs, item, parent, selected }">
        <v-chip
          class="my-2"
          v-bind="attrs"
          :input-value="selected"
          label
          small
          style="height: 50px"
        >
          <div class="d-flex flex-column pr-2">
            <span class="lato-bold f14 black1">
              {{ item.name }}
            </span>
            <span class="gray2">
              {{ item.email }}
            </span>
          </div>
          <v-icon small @click="parent.selectItem(item)"> mdi-close </v-icon>
        </v-chip>
      </template>
      <template #item="{ attrs, item }">
        <div class="d-flex align-center">
          <v-img
            class="mr-3"
            :src="
              attrs['aria-selected'] === 'true'
                ? 'images/selected-icon.svg'
                : 'images/empty-customer-icon.svg'
            "
            width="28"
            height="28"
          />
          <div class="option__desc ml-4">
            <span class="option__title f14">{{ item.name }}</span>
          </div>
        </div>
      </template>
    </v-combobox>
    <div class="approvers-extra-text">
      These admins have permission to add/remove users assigned to this budget entity, as well as
      allocate its balance
    </div>
  </div>
</template>

<script>
import { isEdit, selectedEntity } from '../mixins';

export default {
  name: 'Approvers',
  mixins: [isEdit, selectedEntity],
  props: {
    admins: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.getInitialValue(),
    };
  },
  computed: {
    headerText() {
      return 'Admins';
    },
    subHeaderText() {
      return 'Add admins to budget entity';
    },
  },
  methods: {
    getInitialValue() {
      const adminIds = this.selectedEntity.admin_ids || [];
      return this.admins.filter((a) => adminIds.includes(a.id));
    },
  },
  watch: {
    localValue(val) {
      this.$emit('selected', val);
    },
  },
};
</script>

<style lang="scss">
.v-menu__content {
  margin-top: 0 !important;
}

.approvers-box .v-input__append-inner {
  display: none;
}

.approvers-extra-text {
  display: flex;
  color: #62646a;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;
}
</style>
